import PidDetailEventList from '../container/detail/PidDetailEventList';
function PidDetailEventListPage() {
  return <PidDetailEventList />;
}
export default PidDetailEventListPage;
